export const API_CONFIG = {
  BASE_URL: 'https://sparks-backend-7o5m.vercel.app',
  TIMEOUT: 60000,
  ENDPOINTS: {
    CHAT: '/chat',
    RESET: '/reset',
    HEALTH: '/health'
  }
};

export const STORAGE_KEYS = {
  MESSAGES: 'chatMessages',
  SESSION_ID: 'sessionId'
};

export const SUGGESTIONS = [
  "What does Shravanth build?",
  "Tell me about his projects",
  "What's his tech stack?"
];

export const UI_TEXT = {
  TITLE: "Hi, I'm Shravanth.",
  SUBTITLE: "I build AI agents, RAG systems, and developer tools. This is Spark — my AI. Ask it anything about my work.",
  INPUT_PLACEHOLDER: "Ask me anything about Shravanth",
  LOADING_TEXT: "Typing...",
  FOOTER_MESSAGE: "Conversations may be recorded to improve AI performance.",
  USER_LABEL: "YOU",
  ASSISTANT_LABEL: "SPARK",
  NEW_CONVERSATION_TOOLTIP: "New conversation"
};

export const CONTACT = {
  linkedIn: 'https://www.linkedin.com/in/vshravanth',
  gitHub: 'https://github.com/Shravanth007',
  email: 'vshravanth2004@gmail.com'
};

export const NOTES = {
  URL: '/notes/'
};

export const BOOKING = {
  CAL_LINK: 'https://cal.com/v-shravanth-e3mtsh/30min'
};
